import { Alert, Button, Card, Form, Input, Space, Typography, App as AntdApp } from "antd";
import { ThunderboltOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useState } from "react";
import { api, readErrorMessage } from "../lib/api";

type FormValues = { setupToken: string; initialPassword: string };

export default function InitPage() {
  const { message } = AntdApp.useApp();
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState<"ok" | "already" | null>(null);
  const [form] = Form.useForm<FormValues>();

  const onInit = async (values: FormValues) => {
    setLoading(true);
    try {
      const res = await api.api.setup.init.$post({ json: values });
      if (res.ok) {
        setDone("ok");
        message.success("Khởi tạo dữ liệu mẫu thành công");
      } else {
        const msg = await readErrorMessage(res);
        if (res.status === 409) {
          setDone("already");
          message.warning(msg);
        } else {
          message.error(msg);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "linear-gradient(135deg,#2563EB 0%,#7C3AED 100%)",
        padding: 16,
      }}
    >
      <Card style={{ width: 460 }}>
        <Typography.Title level={3} style={{ textAlign: "center", marginBottom: 24 }}>
          💇 Khởi tạo Salon
        </Typography.Title>

        {done === "ok" && (
          <Alert
            type="success"
            showIcon
            style={{ marginBottom: 16 }}
            title="Đã khởi tạo thành công"
            description={
              <span>
                Tài khoản admin: <code>admin</code> với password vừa đặt. Vào trang đăng nhập để bắt đầu.
              </span>
            }
          />
        )}
        {done === "already" && (
          <Alert
            type="warning"
            showIcon
            style={{ marginBottom: 16 }}
            title="Hệ thống đã được khởi tạo trước đó"
            description="Quay lại trang đăng nhập để sử dụng."
          />
        )}
        {done === null && (
          <Alert
            type="info"
            showIcon
            style={{ marginBottom: 16 }}
            title="Lần đầu sử dụng?"
            description={
              <span>
                Nhập <code>SETUP_TOKEN</code> (đã set qua wrangler secret) và mật khẩu admin
                bạn muốn đặt. Chỉ chạy 1 lần — sau đó nên gỡ secret.
              </span>
            }
          />
        )}

        {done === null && (
          <Form form={form} layout="vertical" onFinish={onInit} disabled={loading}>
            <Form.Item
              label="Setup token"
              name="setupToken"
              rules={[{ required: true, message: "Bắt buộc" }]}
            >
              <Input.Password placeholder="Token từ env SETUP_TOKEN" autoComplete="off" />
            </Form.Item>
            <Form.Item
              label="Mật khẩu admin"
              name="initialPassword"
              rules={[
                { required: true, message: "Bắt buộc" },
                { min: 8, message: "Tối thiểu 8 ký tự" },
              ]}
            >
              <Input.Password placeholder="≥ 8 ký tự" autoComplete="new-password" />
            </Form.Item>
            <Button
              block
              type="primary"
              size="large"
              icon={<ThunderboltOutlined />}
              htmlType="submit"
              loading={loading}
            >
              Khởi tạo dữ liệu mẫu
            </Button>
          </Form>
        )}

        <Space orientation="vertical" style={{ width: "100%", marginTop: 16 }} size="middle">
          <Link to="/login">
            <Button block>Tới trang đăng nhập</Button>
          </Link>
        </Space>
      </Card>
    </div>
  );
}
